// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/journal-entry-batches',
        component: () =>
            import('@/pages/[organisation]/accounting/journal-entry-batches.vue'),
        name: 'accounting.journal-entry-batches.search-journal-entry-batches',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.general-ledger.view-journal-entry-batches',
        },

        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/journal-entry-batches/[id].vue'),
                name: 'accounting.journal-entry-batches.view-journal-entry-batch',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.general-ledger.view-journal-entry-batches',
                },
            },
        ],
    },
];
